import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder, FormControl } from "@angular/forms";
import { ApiService } from '../api.service';

@Component({
  selector: 'app-useredit',
  templateUrl: './useredit.component.html',
  styleUrls: ['./useredit.component.scss']
})
export class UsereditComponent implements OnInit {

  registerForm:FormGroup;
  userList:[];
  userProfilePic:string;

  isSubmitted = false;
  userEmail:string;
  password:string;
  confPassword:string;
  firstName:string;
  lastName:string;
  phone:string;
  hostID:string;
  token_data:string;
  userID:string;
  verifiedStatus:string;
  email:string;  
  agree=false;
  newsLetter = true;
  errormsg:string;
  imageThumb = '';
  selectedFile: File = null;

  
  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private apiService: ApiService) { 


      this.userID = window.atob(this.activatedRoute.snapshot.paramMap.get('userID'));
      

    this.registerForm = this.formBuilder.group({
      image: [''],
      userEmail: ['', [Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password:  ['', [Validators.required, Validators.minLength(6)]],
      confPassword:['',Validators.required],
      firstName:['',[Validators.required,Validators.pattern('^[a-zA-Z ]*$'), Validators.pattern(/^\S/)]],
      lastName:['',[Validators.required,Validators.pattern('^[a-zA-Z ]*$'), Validators.pattern(/^\S/)]],
      phone:['',[Validators.required,Validators.pattern(/^\d{10,11}$/)]],
      agree:[false, Validators.requiredTrue],
      newsLetter:['']
    }
    

    );
  }

  ngOnInit() {

    let userData = {
      token:localStorage.getItem("token_data"),
      userID:localStorage.getItem("userID")     
    }

    this.apiService.userDetails(userData).subscribe((res:any)=>{
     
      this.userList = res.data.getUserData.data;
     

      this.userProfilePic = res.data.getUserData.data.userProfilePic;
      console.log( this.userProfilePic);

  })

}
onFileSelected(event){

}
signup(){

}

}
